var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasSelectedChildsToLastLevel
    ? _c("SelectedItems", {
        attrs: {
          "characteristic-items": _vm.characteristic.children,
          selected: _vm.selected,
          "no-children-appendix": _vm.noChildrenAppendix,
          styling: _vm.styling,
          "label-type": _vm.labelType,
          clickable: true,
          "show-experience": _vm.showExperience
        },
        on: {
          editItem: function($event) {
            return _vm.$emit("editItem", $event)
          }
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }